// components/layout/AdminLayout.tsx
import { Outlet } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import "./layout.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/storage/store";
import RegisterPage from "../../Admin/Register";
import LoginPage from "../../Admin/Login";

export default function AdminLayout() {
    const {isAuthenticated} = useSelector((state:RootState)=>state.auth)
    return (
        isAuthenticated ? 
            <div className="layout">
            <Sidebar />
            <div className="content">
                <Outlet />
            </div>
        </div> :
        <LoginPage/>
        // <RegisterPage/>
    
    );
}
